import { render, staticRenderFns } from "./CommissionLog.vue?vue&type=template&id=0dd4d6e2&scoped=true&"
import script from "./CommissionLog.vue?vue&type=script&lang=ts&"
export * from "./CommissionLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4d6e2",
  null
  
)

export default component.exports